import React from 'react'
import illustration from '../../../../shared/assets/empty-illustration.svg'
import { Badge } from '../../../../lib/ui/badge/component/badge/Badge'

export const TabRemovedStub = () => {
  return (
    <div className={'flex justify-center pb-[44px]'}>
      <div className={'flex w-full max-w-[320px] flex-col items-center gap-[24px]'}>
        <div className={'w-full'}>
          <img alt={'Illustration'} className={'mx-auto max-w-full'} src={illustration} />
        </div>
        <div className={'flex w-full flex-col gap-[24px]'}>
          <div className={'flex w-full flex-col gap-[16px]'}>
            <div className={'flex flex-col items-center'}>
              <h2 className={'text-center text-[24px]'}>No data</h2>
            </div>
            <div
              className={'flex w-full flex-col gap-[16px] rounded-[16px] bg-focus/[0.06] p-[16px]'}
            >
              <p className={'text-center text-focus-500'}>
                See the direct impact of your actions and track the submission history against
                infringing ads
              </p>
            </div>
          </div>
          <div className={'flex flex-col items-center justify-center gap-[8px]'}>
            <p className={'max-w-[254px] text-center text-[13px] leading-[18px] text-[#8E7CA7]'}>
              💡 If the restricted ads infringing on your trademark show up again, you will see them
              in “To submit” tagged as “Repeat”
            </p>
            <div className={'rounded-[8px] bg-focus/[0.06] p-[8px]'}>
              <div className={'flex'}>
                <Badge>Repeat</Badge>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
